<template>
  <div id="container" class="cs_st grid-container">
    <BaseLocation current-group-name="serviceCenter" />

    <!--QNA-->
    <div class="section fill">
      <div class="inner">
        <h2>뉴스레터</h2>
        <p class="sub">CampusBook의 다양한 소식과 이벤트를 만나보세요!</p>
        <!-- Tab START -->
        <div class="link_tab newsLetters">
          <ul>
            <li class="active">
              <span class="link_tab_menu">
                뉴스레터 이미지를 클릭 하시면 해당월 뉴스레터를 바로 보실 수
                있습니다.
              </span>
            </li>
          </ul>
        </div>
        <!-- Tab END -->

        <template v-if="!showDetail">
          <div v-if="getNewsletters" class="tab_detail">
            <div class="tab_page" data-tab-content="tab-newsletter-now">
              <ul class="newsletter_list">
                <li
                  v-for="(newsletter, idx) in getNewsletters"
                  :key="idx"
                  class="newsletter_item"
                >
                  <a
                    class="newsletter_item_wrap"
                    @click="showNewsletterDetail(newsletter)"
                    ><div class="newsletter_image_wrap">
                      <img :src="newsletter.thumbUrl" />
                    </div>
                    <div class="newsletter_meta_wrap">
                      <p class="nslt_title base_NR20">
                        {{ newsletter.title || '타이틀' }}
                      </p>
                      <div class="evt_date">
                        <p class="base_MT14">
                          {{ newsletter.creDtime }}
                        </p>
                      </div>
                      <!-- eslint-disable-next-line vue/no-v-html -->
                      <p
                        class="newsletter_sub_desc"
                        v-html="newsletter.letterDesc"
                      ></p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <EmptyData v-else data-tp="뉴스레터" />

          <pagination
            v-if="getNewsletters"
            :current-page="currentPage"
            :total-count="getNewsletterTotalCount"
            :item-per-page="newslettersPerPage"
            @paginate="paginate"
          />
        </template>

        <template v-if="showDetail && currentNewsletter">
          <div class="newsletter_detail">
            <div class="tit">
              <p class="txt">{{ currentNewsletter.title }}</p>
              <span class="num date"
                >{{ currentNewsletter.creDtime || '0000-00-00' }}
              </span>
            </div>
            <div class="cont">
              <p v-html="currentNewsletter.letterDesc"></p>
            </div>
            <div class="btn_wrap tac">
              <button
                type="summit"
                class="box_btn"
                @click="showNewsletterDetail()"
              >
                <span class="an_t"><a>목록</a></span>
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
    <Sidebar />
  </div>
</template>

<script>
import { NEWSLETTER_GET_LIST } from '@/store/types'
import { mapGetters } from 'vuex'
import BaseLocation from '../../components/base/BaseLocation.vue'
import EmptyData from '../../components/common/EmptyData.vue'

export default {
  name: 'NewsLetters',
  components: { BaseLocation, EmptyData },

  data() {
    return {
      currentPage: 1,
      newslettersPerPage: 10,
      error: null,
      currentNewsletter: null,
      showDetail: false
    }
  },
  computed: {
    ...mapGetters([
      'getNewsletters',
      'getNewsletterTotalCount',
      'isSidebarOpen'
    ])
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      if (to.params.newsletterSeq) {
        try {
          console.log(to.params.newsletterSeq)
          await vm.$store.dispatch(NEWSLETTER_GET_LIST, {
            page: 1,
            pageRow: 10,
            newsletterSeq: to.query.newsletterSeq
          })
          vm.currentNewsletter = vm.$store.getters.getNewsletters[0]
          vm.showDetail = true
          return true
        } catch (err) {
          vm.loadNewsletters()
          next()
          return true
        }
      } else {
        vm.loadNewsletters()
        return true
      }
    })
  },
  mounted() {},
  methods: {
    async loadNewsletters() {
      const { currentPage, newslettersPerPage } = this
      try {
        await this.$store.dispatch(NEWSLETTER_GET_LIST, {
          page: currentPage,
          pageRow: newslettersPerPage
        })
      } catch (err) {
        this.error = err
        console.log(err)
      }
    },
    selectActiveTab(value) {
      this.search = value
      this.currentNewsletter = null
      this.showDetail = false
      this.currentPage = 1
      this.loadNewsletters()
    },
    paginate(page) {
      this.currentPage = page
      this.loadNewsletters()
    },
    showNewsletterDetail(newsletter) {
      if (newsletter) {
        this.currentNewsletter = newsletter
        this.$router.replace({
          query: {
            newsletterSeq: newsletter.newsletterSeq
          }
        })
        this.showDetail = !this.showDetail
        return
      } else {
        this.$router.replace({
          query: null
        })
        this.showDetail = !this.showDetail
      }
    }
  }
}
</script>
<style src="@/assets/css/page_customer.css" scoped></style>
<style lang="scss" scoped>
.newsletter_item {
  width: 100%;
  height: 200px;
  padding: 18px;
  background: #f0f5fa;
  > .newsletter_item_wrap {
    .newsletter_image_wrap {
      overflow: hidden;
      width: 452px;
      height: 100%;
      flex: 0 0 auto;
      background-color: white;
      margin-right: 66px;
    }
    .newsletter_meta_wrap {
      padding: 24px 0px;
      flex: 1 1 auto;
      .newsletter_sub_desc {
        margin-top: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
}
.cs_st .section .inner li > .newsletter_item_wrap {
  display: flex;
}
@media (max-width: 768px) {
  .newsletter_list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    .newsletter_item {
      height: auto;
      padding: 20px 10px;
      > .newsletter_item_wrap {
        .newsletter_image_wrap {
          width: 100%;
          height: auto;
          margin-right: 0;
        }
        .newsletter_meta_wrap {
          padding: 20px 0px 0;
          flex: 1 1 auto;
          .newsletter_sub_desc {
            display: none;
          }
          .base_NR20 {
            font-size: 16px;
            font-weight: 500;
          }
          .nslt_date {
            margin-top: 10px;
          }
          .base_MT14 {
            font-size: 10px;
            font-weight: 500;
          }
        }
      }
    }
  }

  .cs_st .section .inner li > .newsletter_item_wrap {
    flex-direction: column;
  }
  .cs_st .newsletter_list li + li {
    margin-top: 0;
  }
}
</style>
